import { useNewRowAlerts } from './hooks/useNewRowAlerts.js';

// Breakouts only fire during market hours, so there's no point polling outside them.
const isWithinTradingHours = () => {
  const now = new Date();
  const minutes = now.getHours() * 60 + now.getMinutes();
  return minutes >= 9 * 60 + 7 && minutes <= 15 * 60 + 30;
};

// A row is uniquely identified by stock + breakout time + tick level, since the API
// can emit multiple rows per stock (one per bo_tick level).
const rowKey = (row) => `${row.Stock}-${row.time}-${row.BO_tick}`;

// Mounted globally in App.js (inside RowAlertProvider, outside the routed pages) so a new
// Intraday Base breakout pops up no matter which page the user is currently viewing.
const IntradayBaseAlert = () => {
  useNewRowAlerts({
    endpoint: 'https://live1.finstrats.com/strategy_intraday_base_bo',
    rowKey,
    title: 'New Intraday Base Breakout',
    renderDetail: (row) => `${row.Stock}${row.time ? ` at ${row.time}` : ''}`,
    linkTo: '/intraday_base',
    isRowValid: (row) => Boolean(row.Stock),
    isPollingWindowOpen: isWithinTradingHours,
    pollIntervalMs: 60 * 1000,
  });

  return null;
};

export default IntradayBaseAlert;
